import { classNames } from '../utilities';

export const ToggleIcon = ({ fill = '#000', id, className, onClick }) => {
  return (
    <svg
      className={classNames(
        'toggle-icon cursor-pointer',
        className ? className : ''
      )}
      onClick={onClick ? onClick : () => null}
      width="30"
      height="30"
      viewBox="0 0 50 50"
      fill={fill}
      stroke="none"
    >
      <path d="M 0 7.5 L 0 12.5 L 50 12.5 L 50 7.5 Z M 0 22.5 L 0 27.5 L 50 27.5 L 50 22.5 Z M 0 37.5 L 0 42.5 L 50 42.5 L 50 37.5 Z" />
    </svg>
  );
};
